<template>
  <div class="d-flex justify-content-center mt-3">
    <nav class="pagination-custom">
      <div class="page-item disabled" @click="currentSlide > 0 && swiper.slidePrev()">
        <img
          class="control"
          :class="{ 'rotate-180': $i18n.locale === 'en' }"
          src="@/assets/images/home/advocacypillar/right-arrow.png"
          alt="Right Arrow" 
        />
      </div>

      <!-- Dots based on total slides -->
      <span
        v-for="index in totalSlides"
        :key="index"
        class="dot"
        :class="{ active: index - 1 === currentSlide }"
      >•</span>

      <div class="page-item active"  @click="swiper.slideNext()">
        <img
          class="control"
          :class="{ 'rotate-180': $i18n.locale === 'en' }"
          src="@/assets/images/home/advocacypillar/left-arrow.png"
          alt="Left Arrow"
        />
      </div>
    </nav>
  </div>
</template>

<script>
  import { useSwiper } from 'swiper/vue';

export default {
  props: {
    currentSlide: Number, // Active slide index
    totalSlides: Number, // Total slides count
  },
  
  setup() {
      const swiper = useSwiper();

      return {
        swiper,
      };
    },
};
</script>

<style scoped>
.pagination-custom {
  display: flex;
  align-items: center;
}

.page-item {
  border-radius: 8px;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 32px;
  height: 32px;
  font-size: 18px;
  font-weight: bold;
  cursor: pointer;
}

.page-item.active {
  background-color: #c49a3a;
  /* Gold */
  border: none;
  color: white;
}

.page-item.disabled {
  background-color: #f8f5eb;
  /* Light beige */
  border: none;
  color: #d1c4a8;
}

.dot {
  color: #edeade;
  margin: 0 10px;
  font-size: 24px;
  transition: color 0.3s ease-in-out;
}

.dot.active {
  color: #bf9f35;
}

.control {
  height: 12px;
}

.rotate-180 {
  transform: rotate(180deg);
}
</style>
